module.exports = __webpack_public_path__ + "media/images/mobile/solutions/bg26-d23e81fd06a0dbbbe803f9ecdf64cf83.png";